import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ButtonFAB from '@components/ButtonFAB/ButtonFAB';
import CardFilters from '@components/CardFilters/CardFilters';
import GroupButtonGrid from '@components/GroupButtonGrid/GroupButtonGrid';
import DataTable from '@components/DataTable/DataTable';
import { withStyles } from '@material-ui/core';
import swal from '@sweetalert/with-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiThemeProvider } from '@material-ui/core/styles';
import iconAdd from '@images/icone_add.png';
import FilterUtil from '../../filterUtil';
import Loading from '@components/Loading/Loading';
import AnaliseOgmAPI from '@resources/AnaliseOGM';
import { head, operationTypeString } from './headers';
import formatMessage from './i18n/formatMessage';
import { styles, theme } from './AnalieOGM.styles';

/**
 * Componente de listagem de análise OGM
 *
 * @author Gabriela Farias
 * @class Analise OGM
 * @extends {Component} - Componente React
 */
function AnaliseOgm(props) {
  const { classes, history, chipData, itensState } = props;
  const [dataInTable, setDataInTable] = useState([]);
  const [dataAppSync, setDataAppSync] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemSelect, setItemSelect] = useState(null);
  const [disabledEdit, setDisabledEdit] = useState(false);

  useEffect(() => {
    const title = 'analiseOGM.analiseOGM';
    if (itensState.name !== title) {
      props.dispatch({
        type: 'UPDATE_TOOLBAR',
        toolbar: formatMessage(title),
        name: title
      });
    }

    onFilter(chipData);
  }, []);

  /**
   * Busca todos os cadastro para mostrar na listagem
   * @param {*} dataChips
   */
  function onFilter(dataChips) {
    AnaliseOgmAPI.findAllAnaliseOGM()
      .then(query => {
        setDataInTable(FilterUtil.applyFilters(query.data, dataChips));
        setLoading(false);
        setDataAppSync(query.data);
      })
      .catch(() => {
        setDataInTable([]);
        setLoading(false);
        setDataAppSync([]);
      });
  }

  /**
   * Ação ao clicar em editar
   */
  function clickEditar() {
    history.push('/app/analise-ogm/editar/' + itemSelect.idTipoAnaliseOgm);
  }

  /**
   * Açao ao clicar em adicionar
   */
  function clickAdicionar() {
    history.push('/app/analise-ogm/novo');
  }

  /**
   * Açao ao selecionar item na grid
   * @param {*} select - item selecionado
   */
  function selectChange(select) {
    if (select) {
      setItemSelect(select);
      setDisabledEdit(false);
    } else {
      setItemSelect(null);
      setDisabledEdit(true);
    }
  }

  /**
   * Ação ao aplicar filtro
   * @param {*} dataChips - filtro aplicado
   */
  function onFilterChanged(dataChips) {
    setDataInTable(FilterUtil.applyFilters(dataAppSync, dataChips));
  }

  /**
   * Deleta um item selecionado
   */
  function clickExcluir() {
    swal({
      title: formatMessage('analiseOGM.desejaExcluir'),
      icon: 'warning',
      closeOnClickOutside: false,
      closeOnEsc: false,
      buttons: {
        cancel: {
          text: formatMessage('analiseOGM.nao'),
          value: false,
          visible: true,
          closeModal: true,
          className: 'swal2-cancel'
        },
        confirm: {
          text: formatMessage('analiseOGM.excluir'),
          value: true,
          visible: true,
          closeModal: false,
          className: 'swal2-confirm'
        }
      }
    }).then(willDelete => {
      if (willDelete) {
        swal.stopLoading();
        swal(
          <div>
            <MuiThemeProvider theme={theme}>
              <CircularProgress />
            </MuiThemeProvider>
          </div>,
          {
            buttons: false,
            closeOnClickOutside: false,
            title: formatMessage('analiseOGM.excluindo')
          }
        );
        AnaliseOgmAPI.deleteAnaliseOGMById(itemSelect.idTipoAnaliseOgm)
          .then(() => {
            swal(formatMessage('analiseOGM.analiseOGMRemovidoComSucesso'), {
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-Ok'
                }
              }
            }).then(() => {
              atualizarRegistros(itemSelect.idTipoAnaliseOgm);
            });
          })
          .catch(() => {
            swal(formatMessage('analiseOGM,falhaAoExcluirAnaliseOGM'), {
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-error'
                }
              }
            });
          });
      }
    });
  }

  /**
   * Atualiza a grid após deletar item
   * @param {*} analiseOGMDeleted
   */
  function atualizarRegistros(idAnaliseOGMDeleted) {
    let ajusteRegistros = dataAppSync.filter(data => {
      return idAnaliseOGMDeleted !== data.idTipoAnaliseOgm;
    });

    setDataAppSync([...ajusteRegistros]);
    setDataInTable(FilterUtil.applyFilters(ajusteRegistros, chipData));
  }

  return (
    <div className={classes.card}>
      {loading && <Loading />}
      <CardFilters
        filtros={operationTypeString}
        usePaddings={false}
        onFilter={onFilter}
        onFilterChanged={onFilterChanged}
        viewKey='analise-ogm'
      />
      <GroupButtonGrid
        showAdd={false}
        showEdit={true}
        showDelete={true}
        disableEdit={disabledEdit}
        disableDelete={disabledEdit}
        onClickDelete={clickExcluir}
        onClickEdit={clickEditar}
      />

      <div className={classes.cardGrid}>
        <DataTable
          data={dataInTable}
          columns={head}
          selectChange={selectChange}
          showPagination={true}
          pagination={{ length: dataInTable.length, page: 0 }}
        />
      </div>

      <ButtonFAB icon={iconAdd} positionDefault={true} onClick={clickAdicionar} />
    </div>
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'analise-ogm';
  })[0].content
});

let enhaced = withStyles(styles)(AnaliseOgm);
export default withRouter(connect(mapStateToProps)(enhaced));
